import { Stack } from "@mui/material";
import React, { useState } from "react";

import { sumByKeys } from "../../utils/dataManipulation";
import Bullet from "./Bullet";

export const HorizontalStackedBarChartColorBar = ({
  bottom = "-30px",
  className,
  config,
  data,
  height = "2.8rem",
  hoverEffect = true,
}) => {
  const [hoverBulletIndex, setHoverBulletIndex] = useState(null);
  const aggregatedPercentages = sumByKeys({ data, keys: ["percentage"] });
  const totalSum = aggregatedPercentages?.percentage || 1;

  return (
    <Stack className={`${className}   [&>*:first-child]:rounded-l-lg [&>*:last-child]:rounded-r-lg`}>
      {data?.map((row, index) => {
        return (
          <div
            key={index}
            onMouseEnter={() => setHoverBulletIndex(index)}
            onMouseLeave={() => setHoverBulletIndex(null)}
            style={{
              backgroundColor: config[row.label]?.color,
              height,
              position: "relative",
              width: `${(row.percentage * 100) / totalSum}%`,
            }}
          >
            {hoverEffect && index === hoverBulletIndex && (
              <Bullet
                bottom={bottom}
                className="absolute"
                color={config[row.label]?.color}
                height="2.6rem"
                label={`${parseFloat((row.percentage * 100).toFixed(1))}%`}
                left="50%"
                reverse={false}
                textColor={config[row.label]?.textColor}
                transform="translate(-50%, -50%)"
                // top="0px"
                type="circle"
                width="2.6rem"
              />
            )}
            <span
              className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-ds-number-regular-xs"
              style={{
                color: config[row.label]?.textColor ?? "var(--color-foreground-inverse)",
              }}
            >{`${parseFloat((row.percentage * 100).toFixed(1))}%`}</span>
          </div>
        );
      })}
    </Stack>
  );
};
